<template>
    <div>
        <div id="streamModal" class="modal">
            <div class="modal-contents">
              <span class="close" @click="modalClose()">&times;</span>
              <div class="addStream">
                <div class="update-course">
                  <div class="modal-heading">
                    <h1 class="main-heading">Add New Stream</h1>
                  </div>
                  <div class="update-cour">
                    <div class="row">
                      <div class="col-md-12">
                        <form id="add-new-stream" @submit.prevent="addStream($event)">
                          <div class="disTable">
                            <div class="align-center">
                              <div class="form-group addStreamForm">
                                  <label class="ep-input-label" for="stream_name">Stream Name</label>
                                  <select id="stream_name" class="dash-input" name="course_enc_id"
                                    v-model="course_enc_id">
                                      <option value="">Select Stream</option>
                                      <option v-for="gs in getStream" :value="gs.course_enc_id">{{gs.stream}}</option>
                                  </select>
                              </div>
                              <div class="form-group">
                                <button type="submit" class="add-course">Add Stream</button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import toastr from "../../public/js/toastr";
import {requestHeaders} from "../_helpers/apiHelper";

export default {
  data(){
      return{
        getStream: [],
        course_enc_id: '',
    }
  },
  mounted() {
    this.getStreams();
  },
  methods:{

    modalClose() {
      $('#streamModal').css({"display": "none"});
    },
    getStreams(){
        var t = this;
        var url = t.$store.getters.getDomain;
        axios.post(`${url}api/v2/college-profile/get-streams`)
        .then(function (response){
            if(response['data']['response']['status'] == 200){
              t.getStream = response['data']['response']['streams'];
            }
        })
    },
    addStream(){
        var t = this;
        var url = t.$store.getters.getDomain;

        if(!t.course_enc_id){
          alert('Please Select Stream');
          return false
        }
          axios.post(`${url}api/v2/college-profile/save-streams`,{
          course_enc_id: t.course_enc_id,
        },{headers: requestHeaders()})
        .then(res=>{
          if(res['data']['response']['status'] == 200){
              toastr.success('Stream Successfully Added', 'Success');
              t.$parent.streams = res['data']['response']['streams'];
              t.modalClose();
          }
        })
    },
  }
}
</script>

<style scoped>
.addStreamForm label{
  display: block;
}
.align-center{
  text-align: center;
}
.ep-input-label{
  padding: 10px 0 0px 5px;
  font-size: 15px;
  text-transform: uppercase;
  font-family: roboto;
  color: #000;
}
.modal-contents {
  overflow: hidden !important;
  position: relative;
  background-color: #fff;
}

.modal-heading {
  text-align: center;
  padding: 10px;
}

.update-cour {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

form {
  max-width: 550px;
  margin: 0 auto;
  padding: 0px 15px;
}

.add-course {
    background: #00a0e3;
    padding: 10px 15px;
    color: #fff;
    border-radius: 10px 0px 10px 0;
    font-size: 13px;
    border: none;
    margin-top: 15px;
}

.add-course:hover {
    text-decoration: none;
    border-radius: 0px;
    transition: .5s all;
}
</style>